import React, { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useTheme } from "./context/ThemeContext";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import WalletDashboard from "./components/Dashboard/WalletDashboard";
import FundWallet from "./components/Operations/FundWallet";
import Transfer from "./components/Operations/Transfer";
import Withdrawal from "./components/Operations/Withdrawal";
import Sidebar from "./components/Shared/Sidebar";
import ComingSoon from "./components/Shared/ComingSoon";
import "./index.css";
import "./App.css";
import ProtectedRoute from "./ProtectedRoute";

const AppRoutes: React.FC = () => {
  const location = useLocation();
  const [active, setActive] = useState("Wallet");
  const { darkMode, toggleDarkMode } = useTheme();

  // Pages that should NOT show sidebar
  const authPages = ["/login", "/register"];
  const isAuthPage = authPages.includes(location.pathname);

  return (
    <div className="flex min-h-screen bg-white text-gray-900 dark:bg-zinc-950 dark:text-zinc-300">
      {!isAuthPage && (
        <Sidebar
          active={active}
          setActive={setActive}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />
      )}
      <main className="flex-1">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route
            path="/dashboard"
            element={<WalletDashboard darkMode={darkMode} />}
          />
          <Route path="/wallet/fund" element={<FundWallet />} />
          <Route path="/wallet/transfer" element={<Transfer />} />
          <Route path="/wallet/withdraw" element={<Withdrawal />} />

          {/* Coming soon pages */}
          <Route
            path="/customers"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/overview"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/spot-orders"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/margin-orders"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/transactions"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/notification"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/notifications"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route
            path="/settings"
            element={<ComingSoon darkMode={darkMode} />}
          />
          <Route path="/logout" element={<ComingSoon darkMode={darkMode} />} />
          <Route path="/help" element={<ComingSoon darkMode={darkMode} />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
      </main>
    </div>
  );
};

export default AppRoutes;
